import React from "react";
import BrowseHeader from "../components/Nav & Header/BrowseHeader";
import AllCategories from "./components/Tags & Tag/AllCategories";
import NovelsInfiniteScroll from "./components/Infinite ScrollNovels/NovelsInfiniteScroll";
import { Helmet } from "react-helmet";
function Browse() {
  return (
    <div className="">
      <Helmet>
        <meta charSet="utf-8" />
        <title>EyeNovel | Read Free Online Novels in Your Favor</title>
        <meta
          name="description"
          content="Read novel stories online at EyeNovel. You can find genre fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />

        {/* <!-- Google / Search Engine Tags --> */}
        <meta
          itemprop="name"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          itemprop="description"
          content="Read novel stories online at EyeNovel. You can find genre fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />
        <meta
          itemprop="image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:url" content="https://eyenovel.netlify.app" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          property="og:description"
          content="Read novel stories online at EyeNovel. You can find genre fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />
        <meta
          property="og:image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="EyeNovel | Read Free Online Novels in Your Favor"
        />
        <meta
          name="twitter:description"
          content="Read novel stories online at EyeNovel. You can find genre fiction books like: crime, fantasy, romance, science, Western, inspirational, historical, and horror."
        />
        <meta
          name="twitter:image"
          content={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/images/overview1.png`}
        />
        <meta name="author" content="Osama Daimallah" />
      </Helmet>
      <BrowseHeader />
      <AllCategories />
      <NovelsInfiniteScroll />
    </div>
  );
}

export default Browse;
